import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Step2 = ({ formData, onChange, S, labelStyle, inputStyle }) => {
  const { t } = useTranslation();
  // Tenant vocabulary — TenantConfig.claimTypes[] drives the dropdown.
  // When the tenant hasn't populated the list we fall back to the legacy
  // hardcoded options so pre-refactor tenants keep the same dropdown.
  const tenantClaimTypes = useSelector(state => state.tenantConfig?.config?.claimTypes) || [];
  const claimTypeOptions = tenantClaimTypes.length > 0
    ? tenantClaimTypes.map(v => ({ value: v, label: v }))
    : [
        { value: 'daily_sickness',         label: t('screens.claimsScreen.lobDailySicknessAllowance') },
        { value: 'professional_liability', label: t('screens.claimsScreen.lobProfessionalLiabilityEO') },
        { value: 'legal_protection',       label: t('screens.claimsScreen.lobLegalProtection') },
        { value: 'property',               label: t('screens.claimsScreen.lobProperty') },
        { value: 'workers_comp',           label: t('screens.claimsScreen.lobWorkersComp') },
        { value: 'auto',                   label: t('screens.claimsScreen.lobAuto') },
      ];
  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 700, color: S.textPrimary, marginBottom: 6 }}>{t('screens.claimsScreen.new.step2Title')}</div>
      <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 24 }}>{t('screens.claimsScreen.new.step2Desc')}</div>
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{t('screens.claimsScreen.new.lineOfBusiness')}</label>
        <select value={formData.lineOfBusiness} onChange={e => onChange('lineOfBusiness', e.target.value)} style={inputStyle}>
          <option value=''>{t('screens.claimsScreen.new.selectProduct')}</option>
          {claimTypeOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 18 }}>
        <div>
          <label style={labelStyle}>{t('screens.claimsScreen.new.lossDate')}</label>
          <input
            type='date'
            value={formData.lossDate}
            onChange={e => onChange('lossDate', e.target.value)}
            max={new Date().toISOString().split('T')[0]}
            style={inputStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>{t('screens.claimsScreen.new.priority')}</label>
          <select value={formData.priority} onChange={e => onChange('priority', e.target.value)} style={inputStyle}>
            <option value='medium'>{t('screens.claimsScreen.new.priorityMedium')}</option>
            <option value='critical'>{t('screens.claimsScreen.new.priorityCritical')}</option>
            <option value='high'>{t('screens.claimsScreen.new.priorityHigh')}</option>
            <option value='low'>{t('screens.claimsScreen.new.priorityLow')}</option>
          </select>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 18 }}>
        <div>
          <label style={labelStyle}>{t('screens.claimsScreen.new.reportedBy')}</label>
          <select value={formData.reportedBy} onChange={e => onChange('reportedBy', e.target.value)} style={inputStyle}>
            <option value='claimant'>{t('screens.claimsScreen.new.reportedClaimant')}</option>
            <option value='broker'>{t('screens.claimsScreen.new.reportedBroker')}</option>
            <option value='third_party'>{t('screens.claimsScreen.new.reportedThirdParty')}</option>
          </select>
        </div>
        <div>
          <label style={labelStyle}>{t('screens.claimsScreen.new.initialReserve')}</label>
          <input
            type='number'
            min='0'
            step='100'
            value={formData.reserveAmount || ''}
            onChange={e => onChange('reserveAmount', e.target.value === '' ? '' : Number(e.target.value))}
            placeholder='0'
            style={inputStyle}
          />
        </div>
      </div>
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{t('screens.claimsScreen.new.description')}</label>
        <textarea
          value={formData.description}
          onChange={e => onChange('description', e.target.value)}
          placeholder={t('screens.claimsScreen.new.describePlaceholder')}
          style={{ ...inputStyle, minHeight: 120, resize: 'vertical' }}
        />
      </div>
    </div>
  );
};

export default Step2;
